import React, { useState, useEffect, useRef } from 'react';
import SlideDown from 'react-slidedown';
import OutsideClickHandler from 'react-outside-click-handler';

import { WrapperSt, ErrorWrapperSt, ErrorSt } from "../TextField/style";

import Svg from "../../../src/assets/icons/icons.js"

import {
    SelectSt,
    ChosenSt,
    MediumSt,
    ArrowSt,
    ListSt,
    UlSt
} from './style.js';

const Select = (props) => {
    const {
        primary, error, className, content, selectWidth, selectName,
        closeAllSelect, removeAllChoice, removeChoice,
        selectChooseFromLink, selectValueFromLink, filterSave,
        _closeAllSelect, _showSearchingResults,
    } = props;

    const [open, setOpen] = useState(false);
    const [selectValue, setSelectValue] = useState(content[0]);
    const [selectChoose, setSelectChoose] = useState(selectChooseFromLink ? true : false);

    // актуальное значение open для чтения внутри setTimeout
    const openRef = useRef(open);
    openRef.current = open;

    // таймеры, чтобы почистить их при размонтировании
    const timers = useRef([]);
    useEffect(() => () => { timers.current.forEach(clearTimeout) }, []);

    // componentDidMount
    useEffect(() => {
        if (filterSave) {
            setSelectValue(filterSave);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // componentDidUpdate: эффект без списка зависимостей выполняется после каждого рендера,
    // первый (монтирование) пропускаем
    const prevProps = useRef(null);
    // намеренно без списка зависимостей — это перенос componentDidUpdate
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        const prev = prevProps.current;
        prevProps.current = { closeAllSelect, removeAllChoice, removeChoice, selectChooseFromLink };

        if (!prev) return;

        // при открытии второго селектора закрываем первый
        if (closeAllSelect !== prev.closeAllSelect && open === true) {
            setOpen(false);
        }
        // снять все выборы
        if (removeAllChoice !== prev.removeAllChoice) {
            setSelectChoose(false);
            setSelectValue(content[0]);
        }
        // при клике на тег снимается выбор селекта
        if ((removeChoice !== prev.removeChoice) && removeChoice === "0") {
            setSelectChoose(false);
            setSelectValue(content[0]);
        }
        // выделяем нужный селект при переходе через "смотреть все"
        if (selectChooseFromLink) {
            if (selectChooseFromLink !== prev.selectChooseFromLink) {
                if (selectChooseFromLink === selectName) {
                    setSelectChoose(true);
                    setSelectValue(selectValueFromLink);
                }
            }
        }
    });

    // открываем селект
    const _isSelectOpen = () => {
        if (_closeAllSelect && openRef.current === false) _closeAllSelect(); // при открытии второго селектора закрываем первый
        timers.current.push(setTimeout(() => {
            setOpen((prev) => !prev);
        }, 100));
    };

    // меняем значение селекта
    const _isSelectOptionChoose = (x, y) => {
        _showSearchingResults(x);
        if (content[0] !== x) {
            setSelectValue(y ? y : x);
            setOpen(false);
            //из дефолтного вида при клике на выпадающее меню и выборе названия селекта
            if (x !== "0") {
                setSelectChoose(true);
            }
        }
        else {
            setSelectValue(x);
            setOpen(false);
            setSelectChoose(false);
        }
    };

    const li = content[1].map((item, i) => {
        if (item.id) {
            return (<li key={i} onClick={() => _isSelectOptionChoose(item.id, item.name)}>{item.name}</li>)
        }
        else {
            return (<li key={i} onClick={() => _isSelectOptionChoose(item)}>{item}</li>)
        }
    })

    return (
        <>
            <SelectSt>
                <OutsideClickHandler onOutsideClick={() => { setOpen(false) }}>

                    <WrapperSt>
                        <ChosenSt id="chosenStyled" className={className} onClick={() => _isSelectOpen()} open={open} selectChoose={selectChoose} primary={primary}>
                            <MediumSt>
                                {selectValue}
                            </MediumSt>
                            <ArrowSt open={open} >
                                <Svg
                                    className={open ? "keyboard_arrow_top" : ""}
                                    type="keyboard_arrow" />

                            </ArrowSt>
                        </ChosenSt>
                        <ErrorWrapperSt>
                            <ErrorSt>{error}</ErrorSt>
                        </ErrorWrapperSt>
                    </WrapperSt>

                    {primary
                        ?
                        open &&
                        <ListSt id={"test"} selectWidth={selectWidth} >
                            <UlSt>
                                {li}
                            </UlSt>
                        </ListSt>
                        :
                        <ListSt id={"test"} selectWidth={selectWidth}>
                            <SlideDown>
                                {open ? li : null}
                            </SlideDown>
                        </ListSt>
                    }
                </OutsideClickHandler>
            </SelectSt>
        </>
    )
};

export default Select;
